module.exports = __webpack_public_path__ + "static/img/interface01.d9b4142.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/interface01.png
// module id = 7tws
// module chunks = 1